export default {
  model_current: "Current Model",
  model_other: "Other Models",
  restricted: "Restricted to <span class='text-info'>Item Class</span> ",
  subtitle: "Select <span class='text-info'>Model</span> of <span class='text-info'>Item</span>",
}
